import VilgramFileDto from "../../../../../../dto/VilagramFileDto"

export enum ActionType {
    SEEN_SHOW = 'SEEN_SHOW'

}

export interface ActionSeen {
    type: ActionType.SEEN_SHOW
}

type Action = ActionSeen

export default Action